import { ColDef } from 'ag-grid-community';
import GridLayout from '../components/GridLayout';
import { useRecoilCallback, useSetRecoilState } from 'recoil';
import { useGrid } from '../hooks/useGrid';
import {
  deleteEntityGroupCallback,
  entitiesGroupsState,
  EntityGroup,
  getAllEntitiesGroupCallback,
} from '@laborability/commons';
import { appBarState } from '../recoil/states/appBar';
import { useEffect } from 'react';
import { EntitiesGroupForm, LABEL_ENTITY_TYPE } from '../components/Forms';

export function EntitiesGroupPage() {
  const getAllEntitiesGroups = useRecoilCallback(
    getAllEntitiesGroupCallback,
    [],
  );
  const deleteEntitiesGroup = useRecoilCallback(deleteEntityGroupCallback, []);
  const setAppBarName = useSetRecoilState(appBarState);

  const { rowData, handleFetchAll, handleDelete } = useGrid<EntityGroup>({
    state: entitiesGroupsState,
    onFetch: getAllEntitiesGroups,
    onDelete: deleteEntitiesGroup,
  });

  const columnDefs: ColDef[] = [
    {
      field: 'id',
      maxWidth: 100,
      filter: 'agNumberColumnFilter',
      resizable: false,
      headerName: 'ID',
    },
    {
      field: 'name',
      flex: 2,
      filter: 'agTextColumnFilter',
      headerName: 'Gruppo Entità',
    },
    {
      field: 'entity_type',
      flex: 2,
      filter: 'agTextColumnFilter',
      headerName: 'Tipo Entità',
    },
  ];

  const formattedRows = rowData.map(item => {
    if (item.entity_type && item.entity_type in LABEL_ENTITY_TYPE) {
      return { ...item, entity_type: LABEL_ENTITY_TYPE[item.entity_type] };
    }
    return item;
  });

  useEffect(() => {
    setAppBarName("Registrazione gruppi d'entità");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GridLayout<any>
      tableId="entitiesGroup"
      pageName="Gruppo Entità"
      rowData={formattedRows}
      columnDefs={columnDefs}
      handleFetchAll={async () => {
        return await handleFetchAll({ limit: 100000 });
      }}
      handleDelete={handleDelete}
      FormComponent={EntitiesGroupForm}
      recordNameAccessor={item => item.name ?? ''}
    />
  );
}
